import { render, staticRenderFns } from "./TutorialTooltip.vue?vue&type=template&id=3c4fcc73&scoped=true&"
import script from "./TutorialTooltip.vue?vue&type=script&lang=js&"
export * from "./TutorialTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TutorialTooltip.vue?vue&type=style&index=0&id=3c4fcc73&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4fcc73",
  null
  
)

export default component.exports